<template>
  <el-select
    ref="select"
    :value="_value"
    filterable
    :allow-create="canInputCustom"
    placeholder="请选择"
    :remote="!!(isAsyncOptions || valueSearch)"
    :loading="loading"
    :remote-method="remoteMethod"
    :nameKey="nameKey"
    v-bind="props"
    :disabled="disabled"
    default-first-option
    clearable
    @change="handleChange"
    @focus="handleFocus"
    @blur="handleBlur"
  >
    <el-option v-for="item in options" :key="item.value" :label="item[nameKey]" :value="item.value"> </el-option>
  </el-select>
</template>

<script>
import { queryOptions } from '@/servers/prod/center/alibaba';
import storeMixins from '../store-mixins';
import _ from 'lodash';
export default {
  mixins: [storeMixins],
  props: ['props', 'value', 'isMultiComlexItem', 'emitUpdate'],
  data() {
    return {
      isHasOptionsComp: true,
      loading: false,
      isFocus: false,
      options: [],
    };
  },
  computed: {
    key() {
      return this.props.name;
    },
    _value() {
      let value = this.isMultiComlexItem || this.emitUpdate ? this.value : this.alibabaForm[this.key];
      return value;
    },
    nameKey() {
      return this.props.displayName || 'displayName';
    },
    canInputCustom() {
      return this.props.canInputCustom;
    },
    _oriRules() {
      return this.props.dataSource._oriRules || {};
    },
    secondary() {
      // 是否是级联属性
      return this._oriRules.childProp === 'true';
    },
    valueSearch() {
      // 是否调接口获取options
      return this._oriRules.valueSearch;
    },
    parentName() {
      return this.props.dataSource.parentName;
    },
    disabled() {
      const disabledFn = this.props?.dataSource?.disabledFn;
      return disabledFn ? disabledFn() : this.props.disabled;
    },
  },
  watch: {
    options: {
      handler(options) {
        if (this.isFocus) return;
        if (!this._value) return this.onChange('');
        (options.length || this.canInputCustom) && this.checkOptionsValue();
      },
      immediate: true,
      deep: true,
    },
    props: {
      handler(v) {
        if (!v || !v.dataSource) return;
        let { options } = v.dataSource;
        if (this.valueSearch && this.parentName === 'catProp') {
          this.remoteMethod();
          return;
        }
        this.asyncOptionsHandle(options || []);
      },
      immediate: true,
    },
  },
  methods: {
    asyncOptionsHandle(options) {
      const { name, label } = this.props.dataSource;
      const allOptions = options.map(item => ({ ...item, pLabel: label }));

      if (options.length < 100) {
        this.options = allOptions;
        this.isAsyncOptions = false;
        return;
      }
      // 待优化成分页
      // 现在数据量过大导致页面卡顿
      // 目前只取前99条
      const optionList = allOptions.slice(0, 99);
      const _valueIndex = allOptions.findIndex(item => item.value === this._value);
      if (_valueIndex > 99) {
        optionList.unshift(allOptions.find(item => item.value === this._value));
      }
      this.options = optionList;
      this.initAlibabaOptions({ key: name, options: allOptions });
      this.isAsyncOptions = true;
    },
    checkOptionsValue() {
      let isArray = this._value instanceof Array;
      if (isArray) {
        const displayName = this._value
          .map((val, index) => {
            let checkItem = this.checkHasValue(val);
            if (!checkItem && (!isNaN(Number(val)) || !this.canInputCustom)) {
              this._value.splice(index, 1);
            }
            return checkItem ? checkItem[this.nameKey] : false;
          })
          .filter(Boolean);
        this.updateForm({ [`${this.key}_displayName`]: displayName });
        // 没有相同值的话又是可自定义属性，需要给value改为负数
        console.log(this.key, this.parentName, this._value, this.options, '-----checkOptionsValue--')
        if (this.canInputCustom) {
          this.onChange(this._value);
        }
        return;
      }

      if (this.isMultiComlexItem) {
        return;
      }

      let checkItem = this.checkHasValue();
      if (!checkItem) {
        // 没有相同值的话又是可自定义属性，需要给value改为负数
        if (this.canInputCustom) {
          this.onChange(this._value);
        } else {
          // 不能自定义属性就置空
          this.onChange('');
        }
      } else {
        this.updateForm({ [`${this.key}_displayName`]: checkItem.displayName });
      }
    },
    checkHasValue(v) {
      let hasValue = (this.options || []).find(item => item.value === (v || this._value));
      return hasValue;
    },

    onChange(v) {
      if (this.isMultiComlexItem) {
        return this.$emit('change', v);
      }
      const selectCustoms = this.alibabaForm['selectCustoms'] || {};
      let isArray = v instanceof Array;
      let displayName = '';
      // 多选
      if (isArray) {
        displayName = v
          .map(val => {
            return this.getDisplayName(val) || val;
          })
          .filter(Boolean);
      } else {
        displayName = this.getDisplayName(v);
      }
      this.updateForm({ [this.key]: v, [`${this.key}_displayName`]: displayName });
      if (this.canInputCustom && this.parentName === 'catProp') {
        // 若是可自定义输入的选择框，则需要对其进行改造‘
        let multiCustomList = [];
        let newValue = isArray ? v : [v];
        newValue.filter(Boolean).forEach(val => {
          let checkItem = this.checkHasValue(val);
          if (!checkItem) {
            multiCustomList.push(val);
          }
        });
        if (multiCustomList.length) {
          selectCustoms[this.key] = multiCustomList;
        } else {
          delete selectCustoms[this.key];
        }
        this.updateForm({ selectCustoms });
      }
    },
    getDisplayName(v) {
      let checkItem = this.checkHasValue(v) || {};
      return checkItem[this.nameKey];
    },

    updateForm(valueObj) {
      if (this.emitUpdate) {
        this.$emit('change', valueObj);
      } else {
        this.updateAlibabaForm(valueObj);
      }
    },
    handleChange(v) {
      if (this.isMultiComlexItem) {
        return this.$emit('change', v);
      }
      this.onChange(v);
      if (this.secondary && this.parentName === 'catProp') {
        this.$nextTick(() => {
          this.alibabaFormVm.getSecondaryData && this.alibabaFormVm.getSecondaryData();
        });
      }
    },
    handleFocus() {
      this.isFocus = true;
      if (this.isAsyncOptions || this.valueSearch) {
        this.remoteMethod();
      }
    },
    handleBlur() {
      this.isFocus = false;
    },
    async remoteMethod(query = '') {
      this.loading = true;
      if (this.valueSearch && this.parentName === 'catProp') {
        const list = await queryOptions({
          shopId: this.shops_getCategoryPropShopId('alibaba'),
          categoryId: this.alibabaFormVm.categoryId,
          optType: this.valueSearch,
          value: query,
        });
        let options = list.map(item => {
          return {
            value: item.value,
            displayName: item.text,
          };
        });
        if (this._value && this.alibabaForm[`${this.key}_displayName`]) {
          const findValue = options.find(item => item.value === this._value);
          if (!findValue) {
            options.unshift({ value: this._value, displayName: this.alibabaForm[`${this.key}_displayName`] });
          }
        }
        this.options = options;
      } else {
        let options = this.alibabaOptions({ key: this.key, search: query }) || [];
        this.options = options;
      }
      this.loading = false;
    },
  },
  mounted() {},
};
</script>